export enum ReportsEnum {
  JOBS_FOR_INVOICE = 'JOBS_FOR_INVOICE',
  CURRENTLY_ACTIVE_EMPLOYMENTS = 'CURRENTLY_ACTIVE_EMPLOYMENTS',
  EXTERNAL_CANCELLATIONS = 'EXTERNAL_CANCELLATIONS',
  ACTIVITY = 'ACTIVITY',
  TIME_TRACKING = 'TIME_TRACKING',
  SHIFTS_PLANNING = 'SHIFTS_PLANNING',
  JOB_OVERVIEW = 'JOB_OVERVIEW',
  DISPONENT_OVERVIEW = 'DISPONENT_OVERVIEW',
  REQUESTER_OVERVIEW = 'REQUESTER_OVERVIEW',
  POOLER_OVERVIEW = 'POOLER_OVERVIEW',
  AVAILABLE_USER_JOB_PLANNING = 'AVAILABLE_USER_JOB_PLANNING',
  POOLER_REACTION_TIME = 'POOLER_REACTION_TIME',
  SMS_USAGE = 'SMS_USAGE',
  USER_AVAILABILITY = 'USER_AVAILABILITY',
  ARCHIVED_JOBS = 'ARCHIVED_JOBS',
  TRANSFER = 'TRANSFER',
  AVAILABILITY_UPDATES = 'AVAILABILITY_UPDATES',
  PLANNING_MATRIX = 'PLANNING_MATRIX',
  HOURS_BY_DEPARTMENT = 'HOURS_BY_DEPARTMENT',
  CUSTOMER_CONNECTIONS = 'CUSTOMER_CONNECTIONS',
}
